import { Box, Container, LinearProgress, Tab, Tabs, Typography } from "@mui/material";
import { Params, useParams } from "react-router-dom";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import UsuarioService from "../../services/UsuarioService";
import ProyectoService from "../../services/ProyectoService";
import { TablaColaboradoresProyecto } from "../../componentes/Proyectos/TablaColaboradoresProyectos";
import { GetVoidProyectoColaborador, ProyectoColaboradorDTO } from "../../interfaces/ProyectosDTOS/ProyectoColaboradorDTO";
import { GetVoidProyectoDatosGenerales, ProyectoDatosGenerales } from "../../interfaces/ProyectosDatosGenerales";
import { FormColaborador } from "../../componentes/Proyectos/ColaboradorForm";

const usuarioService = new UsuarioService();
const proyectoService = new ProyectoService();

const cardHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

export const ProyectoColaboradorPage: React.FC<{}> = () => {
    const { idProy } = useParams<Params>();
    const idNumber = idProy ? Number(idProy) : 0;
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const userData = casUserContext.userData;
    const [auth, setAuth] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [datosGenerales, setDatosGenerales] = useState<ProyectoDatosGenerales>(GetVoidProyectoDatosGenerales());
    const [colaboradores, setColaboradores] = useState<Array<ProyectoColaboradorDTO>>([]);
    const [ready, setReady] = useState(false);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const fetchData = async () => {
        try {
            await proyectoService.GetColaboradoresProyecto(idNumber, userData.token)
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        //console.log(data.listData)
                        setColaboradores(data.listData);
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const getData = async () => {
        try {
            await proyectoService.GetProyectosDatosGeneralesByIdProyecto(idNumber, userData.token)
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        console.log(data.data)
                        setDatosGenerales(data.data);
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        const flag = usuarioService.authorized(userData.roles);
        getData();
        fetchData();
        setAuth(flag);
        setTimeout(() => {
            setReady(true);
        }, 3000);
    }, [userData]);

    if(!ready){
        return(
            <LinearProgress />
        );
    }

    return (
        <Container sx={{ mt: 5, mb: 4, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
            <Card>
                <CardHeader style={cardHeaderStyles}>
                    <strong>Colaboradores Proyecto</strong>
                </CardHeader>
                <CardBody>
                    <Typography>{datosGenerales.datosGenerales.titulo}</Typography>
                    <Typography>Fecha Inicio: {datosGenerales.datosGenerales.fechainicio.toString().split("T")[0]} - Fecha Fin: {datosGenerales.datosGenerales.fechafin.toString().split("T")[0]}</Typography>
                </CardBody>
                <Container sx={{ mb: 2 }}>
                    {auth ?
                        <Box>
                            <Tabs value={tabIndex} onChange={handleChange} aria-label="Import options">
                                <Tab label="Personal" />
                                {/* <Tab label="Agregar" /> */}
                            </Tabs>
                            <Box mt={2}>
                                {tabIndex === 0 && (
                                    <Box sx={{ width: '100%' }}>
                                        <TablaColaboradoresProyecto idproy={idNumber} icolaboradores={colaboradores} token={userData.token}/>
                                    </Box>
                                )}
                                {tabIndex === 1 && (
                                    <Box sx={{ width: '100%' }}>
                                        <FormColaborador idproy={idNumber} personal={GetVoidProyectoColaborador()} token={userData.token}/>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        :
                        <UnauthorizedPage />
                    }
                </Container>
            </Card>
        </Container>
    );
}